// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XTIITvJ5izRCZitglHwB {
  height: calc(100vh - 60px);
}

.yy04J5QdnqvYNkKcdkzu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60%;
}`, "",{"version":3,"sources":["webpack://./js/view/component/coming-soon/styles.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AACF","sourcesContent":[".hero {\n  height: calc(100vh - 60px);\n}\n\n.heading_container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 60%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `XTIITvJ5izRCZitglHwB`,
	"heading_container": `yy04J5QdnqvYNkKcdkzu`
};
export default ___CSS_LOADER_EXPORT___;
